/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import Metadata from './components/metadata';
import SearchByStateForm from './components/searchByStateForm';
// images
import highResDesktopImage from './components/searchByStateForm/images/usa-map-dot-mosaic.svg';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Insurance',
          linkUrl: '/insurance/',
          linkAriaLabel: 'Northwestern Mutual Insurance',
        },
        {
          pageName: 'Long-term Care Planning',
          linkUrl: '/long-term-care-planning/',
          linkAriaLabel: 'Northwestern Mutual Long Term Care Planning',
        },
        {
          pageName: 'Search by State',
          linkUrl: '/long-term-care-planning/search-by-state/',
          linkAriaLabel: 'Northwestern Mutual Standalone Long Term Care Planning Search by State',
        },
      ]}>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <SearchByStateForm />

    </Page>
  );
};
